import Connection from './Connection';

interface MongoDBConnectionArgs {
  collection_name?: string;
  connection_name?: string;
  query?: string;
  filter?: Record<string, any>;
}

class MongoDBConnection extends Connection {
  constructor(connectionArgs: MongoDBConnectionArgs) {
    super("mongodb_json", connectionArgs);
  }

  static fromJson(json: any): MongoDBConnection {
    return new MongoDBConnection(
      json.connection_args || json.connectionArgs || {}
    );
  }
}

export default MongoDBConnection;